import React, { useEffect, useRef, useState } from 'react'
import { Form, Typography, ColorPicker } from 'antd'
import { useCompanyStore } from '../../store/company/companyStore'
import { useApi } from '../../services/ApiContext'
import debounce from 'debounce'
import { AggregationColor } from 'antd/es/color-picker/color'

const { Title } = Typography

export const BrandingForm = () => {
  const settings = useCompanyStore((state) => state.company.settings)
  const api = useApi()

  const updateBranding = (value: AggregationColor) => {
    api.syncSettings({
      primaryColor: value.toHexString()
    })
  }
  const [color, setColor] = useState<string>(settings.primaryColor)
  const debouncedUpdateBranding = useRef(debounce(updateBranding, 500))

  const updateBrandingAndlocalState = (value: AggregationColor) => {
    setColor(value.toHexString())
    debouncedUpdateBranding.current(value)
  }

  useEffect(() => {
    setColor(settings.primaryColor)
  }, [settings.primaryColor])

  return (
    <>
      <Title level={5} className="mt-8">
        Branding
      </Title>

      <Form.Item label="Brand colour">
        <ColorPicker value={color} onChange={updateBrandingAndlocalState} />
      </Form.Item>

      {/* <Form.Item label="Secondary Color">
        <ColorPicker
          value={branding.secondaryColor}
          onChange={(color) =>
            updateBranding({
              ...branding,
              secondaryColor: color.toHexString()
            })
          }
        />
      </Form.Item> */}
    </>
  )
}
